import axios from "axios";
// Dashboard Data API
export const BuildingManagementData = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "BUILDING_DATA_REQUEST" });
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/all`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      const updatedData = response.data;
      dispatch({
        type: "BUILDING_DATA_SUCCESS",
        payload: updatedData,
      });
    }
  } catch (error) {
    dispatch({
      type: "BUILDING_DATA_FAILURE",
      payload: error.message,
    });
  }
};

export const BuildingManagementFilterData = (filters = {}) => async (dispatch) =>{
 let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "BUILDING_DATA_SEARCH_REQUEST" });
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/building/search`;
    const response = await axios({
      method: "POST",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: filters
    });
    if (response.status === 200) {
      const updatedData = response.data;
      dispatch({
        type: "BUILDING_DATA_SEARCH_SUCCESS",
        payload: updatedData,
      });
    }
  } catch (error) {
    dispatch({
      type: "BUILDING_DATA_SEARCH_FAILURE",
      payload: error.message,
    });
  }
}

// Delete Data API
export const deleteBuidling = (id) => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/${id}`;

  dispatch({ type: "DELETE_BUILDING_REQUEST", payload: id });

  try {
    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "DELETE_BUILDING_SUCCESS",
      });
      dispatch(BuildingManagementData());
    } else {
      dispatch({
        type: "DELETE_BUILDING_FAIL",
      });
    }
  } catch (error) {
    console.error("Failed to delete building:", error);
    dispatch({
      type: "DELETE_BUILDING_FAIL",
      payload:
        error?.response?.data?.message || error.message || "Unknown error",
    });
  }
};

// Add Data APi
export const addBuilding = (formData) => async (dispatch) => {
  dispatch({ type: "ADD_BUILDING_REQUEST" });
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/add`;
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "ADD_BUILDING_SUCCESS",
        payload: response.data,
      });
      dispatch(resestMarkFeild());
    } else {
      dispatch({ type: "ADD_BUILDING_FAIL" });
      dispatch(setToastMessage("Failed to add device"));
    }
  } catch (error) {
    console.error("Failed to add device:", error);

    dispatch({
      type: "ADD_BUILDING_FAIL",
      payload:
        error?.response?.data || error.message || "Unknown error",
    });
  }
};
export const editBuliding = (id, formDataToSend) => async (dispatch) => {
  dispatch({ type: "EDIT_BUILDING_REQUEST" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/${id}`;
    const response = await axios.put(url, formDataToSend, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: "EDIT_BUILDING_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    console.error("Failed to add device:", error);
    dispatch({
      type: "EDIT_BUILDING_FAILURE",
      payload: error?.response?.data || {},
    });
  }
};

export const sendLicenceAction = (formData) => async (dispatch) => {
  dispatch({ type: "SEND_LICENCE_REQUEST" });
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_ALL}/send`;
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "SEND_LICENCE_SUCCESS",
        payload: response.data,
      });
    } else {
      dispatch({ type: "SEND_LICENCE_FAILURE" });
      dispatch(setToastMessage("Failed to add device"));
    }
  } catch (error) {
    console.error("Failed to send License:", error);

    dispatch({
      type: "SEND_LICENCE_FAILURE",
      payload:
        error?.response?.data?.message || error.message || "Unknown error",
    });
  }
};

export const setToastMessage = (message) => ({
  type: "SET_TOAST_MESSAGE",
  payload: message,
});

export const setToastOpen = (isOpen) => ({
  type: "SET_TOAST_OPEN",
  payload: isOpen,
});

export const fetchOnSelectionData = (data) => ({
  type: "MAP_DATA",
  payload: data,
});
export const markerAction = (data) => ({
  type: "MAP_MARKER_DATA",
  payload: data,
});

export const resestMarkFeild = () => ({
  type: "RESET_MARKER_DATA",
});
export const successLicnece = () => ({ 
  type: "CLEAR_LICENCE_SUCCESS"
});
export const customerDataAction = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "CUSTOMER_DATA_REQUEST" });
  try {
    const url = `${process.env.REACT_APP_API_URL}/customer`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      const updatedData = response.data;
      dispatch({
        type: "CUSTOMER_DATA_SUCCESS",
        payload: updatedData,
      });
    }
  } catch (error) {
    dispatch({
      type: "CUSTOMER_DATA_FAILURE",
      payload: error.message,
    });
  }
};

export const fetchUsersFromCustomer = (customerId) => async (dispatch) => {

  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "FETCH_USERS_FROM_CUSTOMER_LOADING" });
  try {
    const url = `${process.env.REACT_APP_API_URL}/customer/${customerId}`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      const updatedData = response.data;
      dispatch({
        type: "FETCH_USERS_FROM_CUSTOMER_SUCCESS",
        payload: updatedData,
      });
    }
  } catch (error) {
    dispatch({
      type: "FETCH_USERS_FROM_CUSTOMER_FAILURE",
      payload: error.message,
    });
  }
};

export const fetchBuidingPersonnelFromCustomer = (customerId) => async (dispatch) => {

  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "FETCH_BUILDING_PERSONEL_FROM_CUSTOMER_LOADING" });
  try {
    const url = `${process.env.REACT_APP_API_ALL}/personell/${customerId}`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      const updatedData = response.data;
      dispatch({
        type: "FETCH_BUILDING_PERSONEL_FROM_CUSTOMER_SUCCESS",
        payload: updatedData,
      });
    }
  } catch (error) {
    dispatch({
      type: "FETCH_BUILDING_PERSONEL_FROM_CUSTOMER_FAILURE",
      payload: error.message,
    });
  }
};